import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MobileDthRecharge = () => {
  // Data for features
  const features = [
    {
      icon: "📱",
      title: "All Operators",
      description:
        "Support for all major telecom and DTH operators including Jio, Airtel, Vi, BSNL, Tata Play, Airtel DTH, and more.",
    },
    {
      icon: "⚡",
      title: "Instant Processing",
      description:
        "Recharges are processed instantly with real-time confirmation and transaction history.",
    },
    {
      icon: "💰",
      title: "Best Commissions",
      description:
        "Earn attractive commissions on every recharge. Commission credited instantly.",
    },
    {
      icon: "🛡️",
      title: "Secure Platform",
      description:
        "Bank-grade security for all transactions. 100% safe, secure and reliable platform.",
    },
    {
      icon: "📊",
      title: "Detailed Reports",
      description:
        "Access complete transaction reports, commission statements, and operator-wise summaries.",
    },
    {
      icon: "🤝",
      title: "24/7 Support",
      description:
        "Dedicated support team available via phone, WhatsApp, and ticket system.",
    },
  ];

  // Supported operators (you can expand)
  const operators = [
    { name: "Jio", category: "mobile", icon: "📱" },
    { name: "Airtel", category: "mobile", icon: "📱" },
    { name: "Vi", category: "mobile", icon: "📱" },
    { name: "BSNL", category: "mobile", icon: "📱" },
    { name: "Tata Play", category: "dth", icon: "📡" },
    { name: "Airtel DTH", category: "dth", icon: "📡" },
    { name: "Dish TV", category: "dth", icon: "📡" },
    { name: "Sun Direct", category: "dth", icon: "📡" },
  ];

  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="service-page recharge-page">
        <Helmet>
          <title>Mobile & DTH Recharge - Panmitra Online Services</title>
          <meta
            name="description"
            content="Offering instant mobile and DTH recharge services for agents and distributors. High commissions, 600+ operators, 24/7 support. Start earning today."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>Mobile & DTH Recharge</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>Mobile & DTH Recharge</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*===== SERVICE OVERVIEW =====*/}
          <section className="service-overview sp1">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="overview-content heading2">
                    <h5>Recharge Services</h5>
                    <h2>Fast, Secure & Profitable Mobile & DTH Recharge</h2>
                    <p>
                      Panmitra offers a comprehensive recharge platform for
                      agents and distributors. Whether it's prepaid mobile,
                      postpaid bill payment, google play recharge, or DTH
                      subscription, our system provides instant processing, high
                      success rates, and competitive commissions. With a single
                      dashboard, you can serve all your customers' recharge
                      needs.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        1500+ operators & biller supported
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        98% success rate
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Real-time transaction status
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Zero Complaints
                      </li>
                    </ul>
                    <div className="btn-area mt-4">
                      <a href="/contact-us" className="header-btn11">
                        Start Earning Now{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="overview-image text-center">
                    <img
                      src="/images/recharge-banner.png"
                      alt="Recharge banner"
                      className="img-fluid rounded-4 shadow"
                      onError={(e) => (e.target.style.display = "none")}
                    />
                    {/* <div
                      className="fallback-icon"
                      style={{ fontSize: "10rem", color: "#dee2e6" }}
                    >
                      <i className="fa-solid fa-mobile-screen-button"></i>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== KEY FEATURES =====*/}
          <section className="features-grid sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Why Agents Love Us</h5>
                    <h2>Powerful Features for Your Recharge Business</h2>
                    <p>
                      We provide everything you need to run a successful
                      recharge business – from an easy-to-use interface to
                      detailed analytics.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-4 mt-4">
                {features.map((feature, idx) => (
                  <div key={idx} className="col-lg-4 col-md-6">
                    <div className="feature-card">
                      <div className="feature-icon">{feature.icon}</div>
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== SUPPORTED OPERATORS =====*/}
          <section className="operators-section sp1">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Wide Coverage</h5>
                    <h2>Supported Operators</h2>
                    <p>
                      We support all major mobile and DTH operators across
                      India. Here are just a few:
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-3 mt-4 justify-content-center">
                {operators.map((op, idx) => (
                  <div key={idx} className="col-lg-3 col-md-4 col-6">
                    <div className="operator-card">
                      <span className="operator-icon">{op.icon}</span>
                      <span className="operator-name">{op.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== HOW IT WORKS =====*/}
          <section className="how-it-works sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Simple Process</h5>
                    <h2>How Recharge Works</h2>
                    <p>Get started in three easy steps</p>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">1</div>
                    <h4>Sign Up</h4>
                    <p>
                      Register as an agent or distributor. Complete quick KYC
                      and get instant ID activation.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">2</div>
                    <h4>Add Funds</h4>
                    <p>
                      Add money to your wallet via UPI or bank transfer. Your
                      balance is ready to use.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">3</div>
                    <h4>Start Recharging</h4>
                    <p>
                      Enter mobile number/DTH subscriber ID, select operator and
                      plan, and confirm. Instant credit!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== CTA SECTION =====*/}
          <section
            className="cta5-section-area sp1"
            style={{
              backgroundImage: "url(assets/img/bg/header-bg5.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="cta-content heading2">
                    <h2 className="text-white">Ready to grow your business?</h2>
                    <p className="text-white">
                      Join thousands of agents earning with Panmitra. Start
                      offering mobile and DTH recharge today.
                    </p>
                    <div className="btn-area mt-4 d-flex justify-content-center flex-wrap gap-3">
                      <a href="/contact-us" className="header-btn11">
                        Become an Agent{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                      <a
                        href="https://developers.instantpanmitra.com"
                        target="_blank"
                        className="header-btn10 text-white"
                      >
                        Explore APIs <i className="fa-solid fa-arrow-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer hideCTA={true} />

      {/* Embedded CSS */}
      <style>{`
        .service-page {
          overflow-x: hidden;
        }
        .service-overview {
          background-color: #fff;
        }
        .overview-content .feature-list {
          list-style: none;
          padding: 0;
          margin: 20px 0 0;
        }
        .overview-content .feature-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
          font-size: 1rem;
          color: #334155;
        }
        .overview-content .feature-list i {
          color: #10b981;
          font-size: 1.3rem;
        }
        .features-grid {
          background-color: #f9fafc;
        }
        .feature-card {
          background: #fff;
          border-radius: 20px;
          padding: 30px 25px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: transform 0.3s ease;
          height: 100%;
          text-align: center;
        }
        .feature-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }
        .feature-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }
        .feature-card h3 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .feature-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .operator-card {
          background: #fff;
          border-radius: 12px;
          padding: 15px;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          border: 1px solid #eef2f6;
        }
        .operator-card:hover {
          border-color: #f39c12;
          box-shadow: 0 8px 20px rgba(243,156,18,0.1);
        }
        .operator-icon {
          font-size: 1.8rem;
        }
        .operator-name {
          font-weight: 600;
          color: #1e293b;
        }
        .step-card {
          text-align: center;
          padding: 30px 20px;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          height: 100%;
        }
        .step-number {
          width: 60px;
          height: 60px;
          background: #f39c12;
          color: #fff;
          font-size: 2rem;
          font-weight: 700;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
        }
        .step-card h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .step-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .service-cta {
          background-color: #f8fafc;
          border-radius: 40px 40px 0 0;
        }
        .fallback-icon {
          opacity: 0.3;
        }
        .btn-area .header-btn10 {
          background: transparent;
          border: 2px solid #f39c12;
          color: #1e293b;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .btn-area .header-btn10:hover {
          background: #f39c12;
          color: #fff;
        }
        @media (max-width: 768px) {
          .feature-card, .step-card {
            padding: 20px;
          }
          .operator-card {
            padding: 10px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default MobileDthRecharge;
